import React from 'react';
import {
  List,
  Datagrid,
  TextField
} from 'react-admin';

const EstadoReglaList = (props) => (
  <List {...props} bulkActionButtons={false}>
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="descripcion" />
    </Datagrid>
  </List>
);

export default EstadoReglaList;
